// Avoid `console` errors in browsers that lack a console.
(function() {
	var method;
	var noop = function() {};
	var methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'];
	var length = methods.length;
	var console = (window.console = window.console || {});

	while (length--) {
		method = methods[length];

		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}
})();
// @codekit-prepend "../../../../../../node_modules/jquery/dist/jquery.js" quiet;

// -----------------------------------------------------------------------------------------
jQuery.noConflict();
(function($) {

	$(document).on('click', '#burger', function() {
		$('.hamburger').toggleClass('is-active');
		$('body').toggleClass('bodyfix');
		$('#main-nav').toggleClass('is-active');
	});

	function closeNav() {
		$('body').removeClass('bodyfix');
		$('#burger').removeClass('is-active');
		$('#main-nav').removeClass('is-active');
	}

	// close the menu with ESC key
	$(document).on('keyup', function(evt) {
		if (evt.keyCode == 27) {
			closeNav();
		}
	});

	// close menu on click outside of the nav
	$(document).click(function(event) {
		var target = $(event.target);
		if (!target.closest('#main-nav').length && !target.closest('#burger').length) {
			closeNav();
		}
	});

	// -----------------------------------------------
	// news teaser 
	const $container = $('.news-teaser .panel');
	const $scrollRight = $('#news-teaser-button');
	const $items = $('.teaser-item');

	if ($container.length && $scrollRight.length && $items.length) {
		function updateButtons() {
			const scrollLeftMax = $container[0].scrollWidth - $container[0].clientWidth;
			const isAtRightEnd = $container.scrollLeft() >= scrollLeftMax - 1;
			const isAtLeftEnd = $container.scrollLeft() <= 0;

			if (isAtRightEnd) {
				$scrollRight.addClass('prev').removeClass('next');
			} else if (isAtLeftEnd) {
				$scrollRight.addClass('next').removeClass('prev');
			}
		}

		function scrollContainer(direction) {
			const itemWidth = $items.outerWidth(true);
			const scrollAmount = direction === 'left' ? -itemWidth : itemWidth;
			$container.animate({ scrollLeft: `+=${scrollAmount}` }, 'smooth', function() {
				updateButtons();
			});
		}

		$scrollRight.on('click', function() {
			if ($(this).hasClass('next')) {
				scrollContainer('right');
			} else {
				scrollContainer('left');
			}
		});

		$container.on('scroll', updateButtons);

		// Initial button state
		updateButtons();
	}




	// // 
	// 	// touch non-touch class helper function
	// 	function is_touch_decvice_bodyclass() {
	// 		const is_touch_device = window.matchMedia("(hover: none),(pointer: coarse)").matches;
	// 		$('body').addClass(is_touch_device ? 'touch-device' : 'none-touch-device');
	// 	}
	// 
	// 	is_touch_decvice_bodyclass();
	// 
	// 	// close related content on touch devices on scroll
	// 	const SCROLL_TOLERANCE = 5; // min pixel to scroll
	// 	let last_scroll_top = 0;
	// 
	// 	$(window).scroll(function() {
	// 		let scroll_top = $(this).scrollTop();
	// 		if (Math.abs(scroll_top - last_scroll_top) > SCROLL_TOLERANCE) {
	// 			if ($('body').hasClass('touch-device')) {
	// 				$('.news-teaser').removeClass('show-teasers');
	// 			}
	// 		}
	// 		last_scroll_top = scroll_top;
	// 	});

	// -----------------------------------------------


	$('.chronicle').on('click', 'button', function() {
		$(this).prop('ariaExpanded', $(this).prop('ariaExpanded') === 'false' ? 'true' : 'false'); // toggle aria 
		$(this).closest('.chronicle-wrapper').find('.chronicle-list').slideToggle(400);
		$(this).find('.open-text').hide();
		$(this).find('.close-text').show();
	});


	$('.accordion').on('click', 'button', function() {
		$(this).closest('.item').find('.copy-wrapper').slideToggle(400);

		$(this).prop('ariaExpanded', $(this).prop('ariaExpanded') === 'false' ? 'true' : 'false'); // toggle aria 

		$(this).closest('.item').find('.open-text').hide();
		$(this).closest('.item').find('.close-text').show();

		$(this).closest('.item').siblings().find('.copy-wrapper').slideUp(400);
		$(this).closest('.item').siblings().find('button').prop('ariaExpanded', 'false');
		$(this).closest('.item').siblings().find('.close-text').hide();
		$(this).closest('.item').siblings().find('.open-text').show();
	});












































})(jQuery);